import { render, staticRenderFns } from "./alternate_device_detail.vue?vue&type=template&id=7cc5d5ab&scoped=true&"
import script from "./alternate_device_detail.vue?vue&type=script&lang=js&"
export * from "./alternate_device_detail.vue?vue&type=script&lang=js&"
import style0 from "./alternate_device_detail.vue?vue&type=style&index=0&id=7cc5d5ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc5d5ab",
  null
  
)

export default component.exports